<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('companiesSettings.listTitle')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :items="formatedcompaniesList"
        :headers="$store.getters['companies/headers']"
        :search="search"
        @selected="(value) => selected = value"
        @edit="editSelection"
        :hideActions="true"
      ></data-table>
    </v-card>
    <v-fab-transition>
      <v-btn v-if="showAddButton" fab dark color="primary" bottom right fixed @click.native="editMode = 'add'; editDialog = true">
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        fab
        dark
        color="red"
        bottom
        right
        fixed
        @click.native="deleteDialog = true"
        style="right: 80px;"
        v-if="selected.length > 0"
        >
        <v-icon dark>delete</v-icon>
      </v-btn>
    </v-fab-transition>
    <company-edit :mode="editMode" :active="editDialog" :id="companyId" @closedialog="editDialog = false; companyId = null"></company-edit>
    <confirmation-dialog :active="deleteDialog" title="Confirmation ?" :message="$tc('companiesSettings.deleteConfirmation', selected.length, {count: selected.length})" :loading="$store.state.users.loading" @confirmation="deleteDemandProfile" @cancel="deleteDialog = false"></confirmation-dialog>
  </v-container>
</template>
<script>
import DataTable from "@/components/DataTable";
import CompanyEdit from "./Company-edit"
import ConfirmationDialog from "@/components/ConfirmationDialog"
export default {
  name: "Companies",
  components: {
    DataTable,
    CompanyEdit,
    ConfirmationDialog
  },
  data() {
    return {
      showAddButton: false,
      search: "",
      selected: [],
      editDialog: false,
      deleteDialog: false,
      companyId: "",
      editMode: "add"
    };
  },
  mounted() {
    this.$store.dispatch("companies/getAll", this.$route.params.id);
    setTimeout(() => this.showAddButton = true, 500)
  },
  methods: {
    editSelection(value) {
      this.editMode = 'edit'
      this.companyId = value
      this.editDialog = true
    },
    async deleteDemandProfile() {
      if (await this.$store.dispatch("companies/delete", this.selected.map(item => item._id))){
        this.deleteDialog = false
        this.selected = []
      }
    }
  },
  computed: {
    formatedcompaniesList () {
      return this.$store.state.companies.list.map(company => {
        company.type = company.simulatedCompany ? this.$t('general.yes') : this.$t('general.no')
        company.dd = company.ddOn ? this.$t('general.yes') : this.$t('general.no')
        return company 
      })
    }
  }
};
</script>
